import { render, staticRenderFns } from "./sevHead.vue?vue&type=template&id=2c408a39&scoped=true&"
import script from "./sevHead.vue?vue&type=script&lang=js&"
export * from "./sevHead.vue?vue&type=script&lang=js&"
import style0 from "./sevHead.vue?vue&type=style&index=0&id=2c408a39&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c408a39",
  null
  
)

export default component.exports